import { BellOutlined } from '@ant-design/icons';
import { t } from '@hefe/i18n';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

interface NewNotificationsAvailableComponentProps {
  onButtonClick: () => void;
}

export default function NewNotificationsAvailableComponent(
  props: NewNotificationsAvailableComponentProps
) {
  const navigate = useNavigate();

  return (
    <Result
      icon={<BellOutlined />}
      title={t('notifications.new_categories.message')}
      extra={
        <Button onClick={() => props.onButtonClick()} type="primary">
          {t('notifications.new_categories.action')}
        </Button>
      }
    />
  );
}
